import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ProgressTrackDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    ringLayer: {
        ...StyleSheet.absoluteFill
    },
    ring: {
        justifyContent: "center",
        alignItems: "center"
    },
    track: {
        flexDirection: "row",
        overflow: "hidden"
    },
    ringValue: {
        textAlign: "center",
        fontVariant: [
            "tabular-nums"
        ]
    }
});

export const useStyles = ({
    currentColors,
    shapeConfigs,
    currentSize,
    radiuses,
    variant,
    spaces
}: ProgressTrackDynamicStyleType) => {
    const styles = {
        track: {
            backgroundColor: currentColors.trackColor,
            height: currentSize.thickness,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    if(variant === "segmented") {
        styles.track = {
            height: currentSize.thickness,
            gap: spaces.spacingXs
        };
    }

    if(variant === "circular") {
        styles.track = {
            height: currentSize.diameter,
            width: currentSize.diameter
        };
    }

    return styles;
};
export default stylesheet;
